<div class="container content mt-5 mt-lg-11 mb-11">
  <div class="row">
    <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
      <div class="card">
        <div class="card-body" [hidden]="complete">
          <div class="row">
            <div class="col">
              <h1 class="card-title">{{ 'Signup' | translate }}</h1>
            </div>
            <div class="col-auto ml-auto">
              <app-language-dropdown></app-language-dropdown>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr class="mb-4 mb-sm-5 mt-1" />
            </div>
          </div>

          <!-- TODO: Add maintenance -->

          <form (ngSubmit)="onRegister()" [formGroup]="registerForm">
            <div class="form-group row">
              <label class="col-form-label col-sm-4" for="email">{{
                'E-mail' | translate
              }}</label>
              <div class="col-sm">
                <input class="form-control" name="email" type="email" novalidate="novalidate" id="email" autofocus=""
                  formControlName="email" [class.is-invalid]="sent && registerForm.get('email').errors" />

                <div class="invalid-feedback" *ngIf="sent && registerForm.get('email').hasError('required')">
                  {{ 'global.validators.required.error' | translate }}
                </div>

                <div class="invalid-feedback" *ngIf="
                    sent && registerForm.get('email').hasError('invalidEmail')
                  ">
                  {{ 'Please enter a valid e-mail' | translate }}
                </div>

                <div class="invalid-feedback" *ngIf="
                    sent && registerForm.get('email').hasError('existingEmail')
                  ">
                  {{ 'E-mail already signed up' | translate }}
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-form-label col-sm-4" for="password">{{
                'Password' | translate
              }}</label>
              <div class="col-sm">
                <input class="form-control" name="password" type="password" novalidate="novalidate" id="password"
                  autofocus="" formControlName="password" [class.is-invalid]="
                    sent &&
                    (registerForm.get('password').hasError('required') ||
                      registerForm.get('password').hasError('minlength'))
                  " />

                <div class="invalid-feedback" *ngIf="
                    sent && registerForm.get('password').hasError('required')
                  ">
                  {{ 'global.validators.required.error' | translate }}
                </div>

                <div class="invalid-feedback" *ngIf="
                    sent && registerForm.get('password').hasError('minlength')
                  ">
                  {{
                    'Password must be at least 8 characters long' | translate
                  }}
                </div>
              </div>
            </div>

            <div class="form-group row pt-3">
              <div class="col-sm-4"></div>
              <div class="col-sm text-center text-sm-left">
                <div class="custom-control custom-checkbox text-muted">
                  <input type="checkbox" class="custom-control-input" id="termsOfService"
                    formControlName="termsOfService" name="termsOfService" [class.is-invalid]="
                      sent && !registerForm.get('termsOfService').value
                    " />

                  <label class="custom-control-label" for="termsOfService">
                    <span class="text-secondary">
                      {{ 'I agree with the' | translate }}
                    </span></label>&nbsp;
                  <a style="cursor: pointer;" href="https://{{
                      !production ? 'test.' : ''
                    }}getapollo.io/{{ currentLang }}/terms-of-service"
                    target="_blank">{{ 'signup.agree.link.toc' | translate }}</a>

                  <div class="invalid-feedback" *ngIf="sent && !registerForm.get('termsOfService').value">
                    {{ 'You must agree with our Terms of Service' | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row pb-3">
              <div class="col-sm-4"></div>
              <div class="col-sm text-center text-sm-left">
                <div class="custom-control custom-checkbox text-muted">
                  <input type="checkbox" class="custom-control-input" id="privacyPolicy" formControlName="privacyPolicy"
                    name="privacyPolicy" [class.is-invalid]="
                      sent && !registerForm.get('privacyPolicy').value
                    " />
                  <label class="custom-control-label" for="privacyPolicy">
                    <span class="text-secondary">
                      {{ 'I agree with the' | translate }}
                    </span></label>&nbsp;
                  <a style="cursor: pointer;" href="https://{{
                      !production ? 'test.' : ''
                    }}getapollo.io/{{ currentLang }}/privacy-policy"
                    target="_blank">{{ 'signup.agree.link.pp' | translate }}</a>

                  <div class="invalid-feedback" *ngIf="sent && !registerForm.get('privacyPolicy').value">
                    {{ 'You must agree with our Privacy Policy' | translate }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-sm text-center">
                <button type="submit" class="btn btn-lg btn-outline-primary btn-wide px-4" [disabled]="loading">
                  <span>{{ 'Signup' | translate }}</span>
                  <i *ngIf="loading" class="fa fa-spinner fa-spin ml-2"></i>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="card-body" [hidden]="!complete">
          <h1 class="card-title">{{ 'Signup successful' | translate }}</h1>
          <hr class="mb-4" />

          <p>
            {{
              'You should be logged in automatically in a few seconds.'
                | translate
            }}
          </p>

          <!-- <p class="small text-muted mb-5">
            {{
              'If you do not receive the e-mail in a couple of minutes the e-mail might have landed in spam.'
                | translate
            }}
          </p> -->

          <p class="small text-muted mb-5">
            {{ 'To log in manually click the link below' | translate }}
          </p>

          <p class="text-center">
            <button [routerLink]="['/login']" routerLinkActive="router-link-active"
              class="btn btn-lg btn-outline-primary pull-right">
              {{ 'Login' | translate }}
            </button>
          </p>
        </div>
      </div>

      <p class="text-center py-4" [hidden]="complete">
        <a style="cursor: pointer;" class="btn btn-link text-secondary"
          [routerLink]="['../login']"><u>{{ 'Already signed up? Login' | translate }}</u></a>
      </p>
    </div>
  </div>
</div>